module.exports = __webpack_public_path__ + "img/paris-saint-germain.c1f749cb.png";